import { createContext } from 'react';

export const CopyInvestorContext = createContext(null);
